export default __webpack_public_path__ + "static/media/sleepnumber_white_logo.79c999f2.png";